/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-06.
 * Action constants types.
 */
const PREFIX = 'suppliers';
export const UPDATE_VALUE = `${PREFIX}_value_updated`;
export const NOTIFY = `${PREFIX}_notify`;
export const FETCH_DATA = `${PREFIX}_fetch_data`;
export const FETCHING = `${PREFIX}_fetching`;
export const FETCH_COMPLETE = `${PREFIX}_fetch_complete`;
export const EDITING_ITEM = `${PREFIX}_editing_item`;



// WEBPACK FOOTER //
// ./containers/proveedores/types.js